import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';
import createFold from './fold';

// "Read more" under a shortened Project Story text; hidden when the whole text already shows.
function initStory(root: HTMLElement): void {
	const text = root.querySelector<HTMLElement>('[data-armada-story-text]');
	const button = root.querySelector<HTMLButtonElement>('[data-armada-story-more]');

	if (!text || !button) {
		return;
	}

	const more = button.textContent ?? '';
	const less = button.dataset.less || more;

	const sync = (): void => {
		if (root.classList.contains('is-open')) {
			return;
		}

		// Beside a photo the button sits over the last lines, so those count as hidden too.
		const covered = parseFloat(getComputedStyle(button).marginTop) < 0 ? button.offsetHeight : 0;
		const last = text.lastElementChild;
		const used = last ? last.getBoundingClientRect().bottom - text.getBoundingClientRect().top : text.scrollHeight;

		button.hidden = used <= text.clientHeight - covered + 2;
		root.classList.toggle('is-fit', button.hidden);
	};

	const toggle = createFold(root, text, button);

	button.addEventListener('click', () => {
		const open = toggle();

		button.setAttribute('aria-expanded', String(open));
		button.textContent = open ? less : more;
	});

	sync();
	window.addEventListener('resize', sync, { passive: true });
}

function initSlider(root: HTMLElement): void {
	const block = root.closest<HTMLElement>('.armada-photo-slider');

	new Swiper(root, {
		modules: [A11y, Keyboard, Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 16,
		loop: root.querySelectorAll('.swiper-slide').length > 1,
		keyboard: { enabled: true, onlyInViewport: true },
		navigation: {
			prevEl: root.querySelector<HTMLElement>('.armada-photo-slider__arrow--prev'),
			nextEl: root.querySelector<HTMLElement>('.armada-photo-slider__arrow--next'),
		},
		pagination: {
			el: block?.querySelector<HTMLElement>('.armada-photo-slider__dots'),
			clickable: true,
			bulletClass: 'armada-dot',
			bulletActiveClass: 'is-active',
		},
	});
}

export default function initProject(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-story]').forEach(initStory);
	document.querySelectorAll<HTMLElement>('[data-armada-photo-slider]').forEach(initSlider);
}
